import React from 'react';
import PropTypes from 'prop-types';
import { crosstabViewTextEllipsis } from '../../../util/CrosstabUtils';
import { GRID_ROW_COL_MAX_TEXT } from '../../../constants';

const GridItemName = props => {
  const handleRestore = () => {
    props.restoreGridTitle(props.index, props.gridType);
  };
  const originalName = crosstabViewTextEllipsis(props.gridType, props.body);
  return (
    <React.Fragment>
      <div className="griditem-name-header">
        {props.header}
      </div>
      <div className="griditem-name-body">
        {originalName}
        {originalName.length >= GRID_ROW_COL_MAX_TEXT ? '...' : ''}
      </div>
      <div className="griditem-name-btn">
        {
          (props.ShowRestoreButton) &&
            <div className="griditem-name-inner-btn">
              <button onClick={handleRestore} className="griditem-name-restore-btn">
                <div className="griditem-name-retore-txt">RESTORE</div>
              </button>
            </div>
        }
      </div>
    </React.Fragment>
  );
};

GridItemName.propTypes = {
  header: PropTypes.string,
  body: PropTypes.string,
  ShowRestoreButton: PropTypes.bool,
  index: PropTypes.number,
  gridType: PropTypes.string,
  restoreGridTitle: PropTypes.func,
};

export default GridItemName;
